import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Primeros Auxilios para tu Bebé',
    text: 'Para actuar con calma en momentos que pueden asustar',
    image: 'https://cdn.magicpatterns.com/uploads/jqoMMD1P1yzQw8rEvpLdJF/2114d6e4-8026-4ff2-bc1e-b7b0b0467235.png',
    emoji: '🚑'
  }, {
    title: 'Carpeta Prenatal Inteligente',
    text: 'Para organizar cada etapa sin sentirte abrumada',
    image: 'https://cdn.magicpatterns.com/uploads/mqDiGErKSjh21EFDy9aVEX/6e27915d-d49b-4105-b320-286d4047a1c6.png',
    emoji: '📂'
  }, {
    title: 'Primeras comidas de tu bebé',
    text: 'Para acompañar cada etapa con claridad',
    image: 'https://cdn.magicpatterns.com/uploads/24xQ36SZ6UXVg394AVD8wU/0db7fcb1-ead9-4325-8a42-110949da6b34.png',
    emoji: '🥣'
  }];
  return <section className="w-full bg-white py-16 md:py-24 px-6" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="font-serif text-3xl md:text-5xl text-charcoal-700 mb-5 leading-tight uppercase tracking-wide" data-id="element-29">
            Contenido adicional para acompañarte en cada etapa
          </h2>
          <p className="text-lg md:text-xl text-charcoal-400 font-light max-w-2xl mx-auto mb-4" data-id="element-30">
            Al acceder a Florecer, también recibís guías prácticas pensadas para
            sostenerte en este proceso:
          </p>
          <p className="text-warm-500 font-medium tracking-wider uppercase text-sm" data-id="element-31">
            🎁 Hoy incluidos sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-32">
          {bonuses.map((bonus, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-33">
              <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block mb-5 transition-opacity duration-500 group-hover:opacity-90" data-id="element-34">
                <img src={bonus.image} alt={bonus.title} className="w-[300px] h-[300px] object-contain mx-auto" data-id="element-35" />
              </a>

              <h3 className="font-serif text-xl text-charcoal-700 mb-3 flex items-center justify-center gap-2" data-id="element-36">
                <span data-id="element-37">{bonus.emoji}</span> {bonus.title}
              </h3>

              <p className="text-charcoal-400 font-light px-4" data-id="element-38">{bonus.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}